import {
  AI2Banner
} from "./chunk-7WX3CAJ3.js";
import {
  Logo
} from "./chunk-WYIG2UKD.js";
import {
  AppName
} from "./chunk-J2XSX3HI.js";
import {
  AppTagline
} from "./chunk-EWCNTEL6.js";
import {
  useSmartAI2Banner
} from "./chunk-OKWD3XCP.js";
import {
  Content
} from "./chunk-WQQCTYOM.js";

// src/components/header/Header.tsx
import { AppBar, Toolbar, styled } from "@mui/material";
import { useRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var Content2 = styled(Content)`
    padding-top: 0;
    padding-bottom: 0;
`;
var StyledAppBar = styled(AppBar)`
    background-color: ${({ theme }) => theme.palette.common.white};
    color: ${({ theme }) => theme.palette.text.primary};
    size: ${({ theme }) => theme.font.size["3xl"]};
    box-shadow: 0px ${({ theme }) => theme.spacing(0.5, 2)} rgba(10, 41, 57, 0.08);
    transition: top 200ms ease-in-out;
    top: ${({ top }) => top}px;
`;
function HeaderComponent({
  children,
  customBanner: Banner = /* @__PURE__ */ jsx(AI2Banner, {}),
  bannerAlwaysVisible = false,
  containerRef,
  ...appBarProps
}) {
  const bannerRef = useRef(null);
  const appBarRef = useRef(null);
  const topOffset = useSmartAI2Banner({
    containerRef,
    appBarRef,
    bannerRef,
    bannerAlwaysVisible
  });
  return /* @__PURE__ */ jsxs(StyledAppBar, { ...appBarProps, position: "sticky", top: topOffset, ref: appBarRef, children: [
    /* @__PURE__ */ jsx("div", { ref: bannerRef, children: Banner }),
    children ? /* @__PURE__ */ jsx(Toolbar, { disableGutters: true, children: /* @__PURE__ */ jsx(Content2, { children }) }) : null
  ] });
}
var Columns = styled(({ columns, ...rest }) => /* @__PURE__ */ jsx("div", { ...rest }))`
    display: grid;
    grid-template-columns: ${({ columns }) => columns};
    grid-column-gap: ${({ theme }) => theme.spacing(2)};
    grid-row-gap: ${({ theme }) => theme.spacing(2)};
    width: 100%;
    align-items: center;
    padding: ${({ theme }) => theme.spacing(1.5)} 0;
`;
var MenuColumn = styled("div")`
    justify-self: right;
    line-height: 77px;

    a:hover {
        text-decoration: none;
    }

    ul {
        margin: -${({ theme }) => theme.spacing(1.5)} 0;
    }
`;
var Header = Object.assign(HeaderComponent, {
  AI2Banner,
  AppName,
  AppTagline,
  Columns,
  Logo,
  MenuColumn
});

export {
  Header
};
//# sourceMappingURL=chunk-Z6PBZPMI.js.map